import { type ChangeEvent, useState } from 'react';
import { eventsApi } from '../api/events';

type Props = {
  value: string | null;
  onChange: (publicUrl: string | null) => void;
};

export function LogoUpload({ value, onChange }: Props) {
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onFile = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setErr(null);
    setUploading(true);
    try {
      const { uploadUrl, publicUrl } = await eventsApi.uploadUrl(file.name, file.type);
      const res = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: { 'Content-Type': file.type },
      });
      if (!res.ok) throw new Error(`upload failed: ${res.status}`);
      onChange(publicUrl);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="stack">
      {value && (
        <img src={value} alt="logo" width={96} height={96} style={{ borderRadius: 8, objectFit: 'cover' }} />
      )}
      <input type="file" accept="image/png,image/jpeg,image/webp" onChange={onFile} disabled={uploading} />
      {uploading && <span className="muted">Uploading…</span>}
      {err && <div className="error">{err}</div>}
      {value && (
        <button type="button" onClick={() => onChange(null)} style={{ background: 'none', border: 'none', color: 'var(--color-danger)', cursor: 'pointer', textAlign: 'left' }}>
          Remove logo
        </button>
      )}
    </div>
  );
}
